import * as dd from 'dingtalk-jsapi'

/* eslint-disable */
export function GetCode(callback) {
    const corpId = 'dingd424e73ca3b79af9f2c783f7214b6d69' //钉钉企业id
    console.log(corpId,'pid');
    if (dd.env.platform !== 'notInDingTalk') {
        dd.ready(() => {
            dd.runtime.permission.requestAuthCode({
                corpId: corpId,
                onSuccess: (info) => {
                    console.log(info,'info');
                    callback(info.code)
                },
                onFail: (err) => {
                    alert('fail')
                    alert(JSON.stringify(err))
                }
            })
        })
    }
}
